(function() {
  function moveLooxRating() {
    const looxBlock = document.querySelector('[id*="loox_rating"]');
    const avaliacaoDiv = document.querySelector('.avaliacao');

    if (looxBlock && avaliacaoDiv && !avaliacaoDiv.contains(looxBlock)) {
      avaliacaoDiv.appendChild(looxBlock);
      return true;
    }
    return false;
  }

  function initLooxRating() {
    if (moveLooxRating()) return;

    const observer = new MutationObserver(function() {
      if (moveLooxRating()) {
        observer.disconnect();
        clearTimeout(timeout);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    const timeout = setTimeout(function() {
      observer.disconnect();
    }, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLooxRating);
  } else {
    initLooxRating();
  }

  document.addEventListener('shopify:section:load', initLooxRating);
})();

// Add to Cart functionality for product cards without variants
(function() {
  function setupProductCardAddToCart() {
    const addToCartButtons = document.querySelectorAll('.product-card .add-to-cart-btn');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const variantId = this.dataset.variantId;
        if (!variantId) return;
        
        // Disable button and show loading state
        const originalHTML = this.innerHTML;
        this.disabled = true;
        this.style.opacity = '0.6';
        this.style.cursor = 'not-allowed';
        
        try {
          // Add item to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              sections: 'cart-drawer,cart-icon-bubble',
              sections_url: window.location.pathname
            })
          });
          
          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }
          
          const data = await response.json();
          
          // Update cart drawer content
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && data.sections) {
            cartDrawer.renderContents(data);
          }
          
          // Publish cart update event if available
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-card',
              cartData: data
            });
          }
          
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Erro ao adicionar produto ao carrinho. Tente novamente.');
        } finally {
          // Re-enable button
          this.disabled = false;
          this.style.opacity = '1';
          this.style.cursor = 'pointer';
          this.innerHTML = originalHTML;
        }
      });
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductCardAddToCart);
  } else {
    setupProductCardAddToCart();
  }
  
  // Re-initialize when new products are loaded (for AJAX pagination, filters, etc.)
  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', setupProductCardAddToCart);
  }
})();
